<template>
  <v-layout row wrap>
    <v-flex xs6 sm6>
      <v-menu
        lazy
        :close-on-content-click="false"
        v-model="from_menu"
        transition="scale-transition"
        offset-y
        full-width
        :nudge-right="40"
        max-width="290px"
        min-width="290px"
      >
        <v-text-field
          slot="activator"
          label="Picker in menu"
          v-model="from"
          prepend-icon="event"
          readonly
        ></v-text-field>
        <v-date-picker v-model="from" no-title scrollable actions>
          <template scope="{ save, cancel }">
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
              <v-btn flat color="primary" @click="save">OK</v-btn>
            </v-card-actions>
          </template>
        </v-date-picker>
      </v-menu>
    </v-flex>
    <v-spacer></v-spacer>
        <v-flex xs6 sm6>
      <v-menu
        lazy
        :close-on-content-click="false"
        v-model="to_menu"
        transition="scale-transition"
        offset-y
        full-width
        :nudge-right="40"
        max-width="290px"
        min-width="290px"
      >
        <v-text-field
          slot="activator"
          label="Picker in menu"
          v-model="to"
          prepend-icon="event"
          readonly
        ></v-text-field>
        <v-date-picker v-model="to" no-title scrollable actions>
          <template scope="{ save, cancel }">
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
              <v-btn flat color="primary" @click="save">OK</v-btn>
            </v-card-actions>
          </template>
        </v-date-picker>
      </v-menu>
    </v-flex>
  </v-layout>
</template>


<script>
  export default {
    data: () => ({
      from: null,
      to:null,
      from_menu: false,
      to_menu: false
    }),
    watch:{
        from(newValue){
            console.log('from newValue',newValue)
            if(this.to&&this.to!==null  && newValue && newValue!==null){
                this.$emit('change',{
                    from:newValue,
                    to:this.to
                })
            }
        },
        to(newValue){
            console.log('to newValue22222',newValue)
            if(this.from&&this.from!==null && newValue && newValue!==null){
                this.$emit('change',{
                    from:this.from,
                    to:newValue
                })
            }
        }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Admin/Reports/ReportsPickers.vue